// extracted by mini-css-extract-plugin
module.exports = {"VendorBadge":"VendorBadge_VendorBadge__35rps"};